export default __webpack_public_path__ + "static/media/feature4.cde52993.webp";